var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2061_302)","key":0},React.createElement("path",{"d":"M30.8332 22.5H27.4998V17.5H22.4998V22.5H19.1665L24.9998 28.3333L30.8332 22.5ZM19.1665 30V31.6667H30.8332V30H19.1665Z","fill":"white"})),React.createElement("circle",{"opacity":"0.3","cx":"25","cy":"25","r":"24.5","stroke":"white","key":1}),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0_2061_302"},React.createElement("rect",{"width":"20","height":"20","fill":"white","transform":"translate(15 15)"})))]);
}

Download.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = Download;

Download.default = Download;
